import type { TileViewModel } from '@rocco/ui/tile-shared/view-models/tile';
import type { ProductTileViewModel } from '@rocco/ui/tile-product/view-models/product';

/**
 * Initial Similar Products grid size by device. Multiples of the grid columns
 * (4 desktop / 2 mobile) so the first page fills complete rows, and aligned with
 * the client "Load More" page size so subsequent offsets line up. Lives in a
 * neutral (non-`.server`) module so the client hook can import it too.
 */
export const SIMILAR_PRODUCTS_PAGE_SIZE = { desktop: 16, mobile: 4 } as const;

export interface SimilarProductsPage {
    products: TileViewModel<ProductTileViewModel>[];
    hasMore: boolean;
    totalCount: number;
}
